'use client'

import { Spinner } from '@lastbrand/web-ui/spinner'
import { css, cx } from '@lastbrand/web-ui-styled-system/css'

import type { LoaderWrapperDSProps } from './loader-wrapper-ds.types'

const MAX_NATIVE_SPINNER_SIZE = 40

const loaderWrapperClass = css({
  position: 'relative',
  my: 'space-64',
  mx: 'auto',
  justifyContent: 'center',
})

export function LoaderWrapperDS({
  testid,
  showLoader,
  minHeight = '300px',
  children,
  loadWrapperClassName,
  containerClassName,
  childrenClassName,
  loaderSize = 40,
}: LoaderWrapperDSProps) {
  return (
    <div data-testid={testid} className={cx(containerClassName)}>
      <div
        style={{ display: showLoader ? 'flex' : 'none', minHeight }}
        className={cx(loaderWrapperClass, loadWrapperClassName)}
      >
        <Spinner
          variant="cantaloupe"
          {...(loaderSize <= MAX_NATIVE_SPINNER_SIZE
            ? { size: loaderSize }
            : { style: { width: loaderSize, height: loaderSize } })}
        />
      </div>
      <div className={cx(childrenClassName)} style={showLoader ? { display: 'none' } : undefined}>
        {children}
      </div>
    </div>
  )
}
